export default "__VITE_ASSET__DGtRs4AF__"